import {ReactElement} from 'react';
import {LoginPage} from '../auth/ui/login-page';
import {GuestRoute} from '../auth/guards/guest-route';
import {RegisterPage} from '../auth/ui/register-page';
import {useSettings} from '../core/settings/use-settings';

interface DynamicHomepageProps {
  homepageResolver: (type: string) => ReactElement;
}
export function DynamicHomepage({homepageResolver}: DynamicHomepageProps) {
  const settings = useSettings();
  const homepageType = settings?.homepage?.type;

  if (homepageType === 'loginPage') {
    return (
      <GuestRoute>
        <LoginPage />
      </GuestRoute>
    );
  }

  if (homepageType === 'registerPage') {
    return (
      <GuestRoute>
        <RegisterPage />
      </GuestRoute>
    );
  }

  // Provide a fallback if homepage type is not available
  if (!homepageType) {
    return null;
  }

  return homepageResolver(homepageType);
}
